import { HttpContextToken } from '@angular/common/http';

export type InvalidFormParam = {
  key: string;
  message: string;
};

export interface ServerResponse<T = any> {
  data: T;
}

export type ServerTextErrorResponse = ServerResponse<{ message: string }>
export type ServerInvalidFormResponse = ServerResponse<{ invalidParams: InvalidFormParam[]; }>

export const THROW_ERROR = new HttpContextToken<boolean>(() => false);
export const ERROR_CALLBACK = new HttpContextToken<Function|null>(() => null);